<template>
  <section class="content">
    <!-- Default box -->
    <div class="box">
      <div class="box-header with-border">
        <h3 class="box-title">Settings</h3>
      </div>
      <div class="box-body" style="height: 100%;min-height: 700px;">
        <!-- start tab -->
        <div class="row">
              <div class="col-5 col-sm-3 sideborder">
                <ul class="nav nav-pills nav-stacked post">
                  <li v-if="userInfo.master_id == null" v-bind:class="{'active': tabOne && userInfo.master_id == null}" @click="tabOne = true, tabTwo = false, tabThree = false, tabFour = false"><a>User Management</a></li>
                  <li v-bind:class="{'active': tabTwo && userInfo.master_id != null}" @click="tabOne = false, tabTwo = true, tabThree = false, tabFour = false"><a>Security Settings</a></li>
                  <li v-bind:class="{'active': tabThree}" @click="tabOne = false, tabTwo = false, tabThree = true, tabFour = false"><a>Payment</a></li>
                  <li v-bind:class="{'active': tabFour}" @click="tabOne = false, tabTwo = false, tabThree = false, tabFour = true"><a>Account Preferences</a></li>
                </ul>
              </div>
              <div class="col-sm-9">
                <!-- <carousel :per-page="5" :paginationEnabled="false" :navigate-to="someLocalProperty" :navigationEnabled="true" :mouse-drag="false">
                  <slide v-for="x in 15" :key="x">
                    {{getdate(x)}}
                  </slide>
                </carousel> -->
                <div v-if="tabOne">
                  <div class="box-header with-border" style="padding: 11px;" v-if="showlist">
                    <h3 class="box-title">Current Users</h3>
                    <div class="box-tools pull-right">
                      <a href="javascript:void(0)" @click="open()" class="btn btn-sm sbtn pull-right">Add User</a>
                      <button href="javascript:void(0)" @click="back()" class="btn btn-sm btn-default pull-right mr-11">Back</button>
                    </div>
                  </div>
                  <ul class="products-list product-list-in-box" v-if="adduser">
                    <li class="item">
                      <div class="product-info" style="margin-left: 6px;">
                        <div class="col-md-8">
                          <span class="product-title">Users
                            <!-- <span class="label label-warning pull-right">$1800</span> -->
                          </span>
                          <span class="product-description">
                            <a class="gc" @click="viewusers()">{{userslistlength}} users</a> added to your account
                          </span>
                        </div>
                        <div class="col-md-4">
                          <a href="javascript:void(0)" @click="open()" class="btn btn-sm sbtn pull-right">Add User</a>
                          <a href="javascript:void(0)" @click="viewusers()" class="btn-flat pull-right mt-2 mr-11 gc">View all users</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <div style="margin-top: 25%;text-align:center" v-if="userslistlength < 1 && showlist">
                      <img src="../assets/img/nodata.svg" alt="Product Image" style="width: 80px;">
                  </div>
                  <table class="table" v-if="userslistlength > 0 && showlist">
                    <tbody>
                      <tr style="background-color: #cccccc57;">
                        <td>First Name</td>
                        <td>Last Name</td>
                        <td>Mail Id</td>
                        <td>Team Name</td>
                        <!-- <td style="width:113px"></td>
                        <td>Action</td> -->
                      </tr>
                      <tr v-for="item in userslist" :key="item.first_name">
                        <td>{{item.first_name}}</td>
                        <td>{{item.last_name}}</td>
                        <td>{{item.email}}</td>
                        <td>{{item.team_name}}</td>
                        <!-- <td><a href="javascript:void(0)" @click="viewusers()" class="btn-flat pull-right mt-2 mr-11 gc">View details</a></td>
                        <td> <a><i class="uil uil-ellipsis-h fa-2x"></i></a></td> -->
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="tabTwo">
                  <div class="box-header with-border" style="padding: 11px;">
                    <h3 class="box-title">Security Settings</h3>
                  </div>
                  <div class="box-header with-border" style="background-color: #f1f1f1;">Change Password</div>
                  <div class="col-md-12">
                    <b-form class="register-form" id="resets" v-on:submit.prevent="onSubmitProfile" novalidate>
                      <div class="row mt-2">
                        <div class="form-row">
                          <div class="form-group">
                            <b-form-input @keyup="changepass()" v-model.lazy.trim="$v.form2.cpassword.$model" :type="passwordFieldType1" placeholder="Enter Current Password *" :state="chkState2('cpassword')"/>
                            <span class="uil uil-eye field-icon toggle-password" v-if="passwordFieldType1 == 'text'" @click="switchVisibility1"></span>
                            <span class="uil uil-eye-slash field-icon toggle-password" v-if="passwordFieldType1 == 'password'" @click="switchVisibility1"></span>
                            <div v-if="$v.form2.cpassword.$error">
                              <p v-if="!$v.form2.cpassword.required" class="login-alert-msg error-content mb-1">* Enter current password</p>
                            </div>
                            <div v-if="olderror">
                              <p class="login-alert-msg error-content mb-1">* Incorrect Password</p>
                            </div>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group">
                            <b-form-input v-model.lazy.trim="$v.form2.npassword.$model" type="password" placeholder="Enter New Password *" :state="chkState2('npassword')"/>
                            <div v-if="$v.form2.npassword.$error">
                              <p v-if="!$v.form2.npassword.required" class="login-alert-msg error-content mb-1">* Enter new password</p>
                            </div>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group">
                            <b-form-input v-model.lazy.trim="$v.form2.ncpassword.$model" :type="passwordFieldType" placeholder="Confirm New Password *" :state="chkState2('ncpassword')"/>
                            <span class="uil uil-eye field-icon toggle-password" v-if="passwordFieldType == 'text'" @click="switchVisibility"></span>
                            <span class="uil uil-eye-slash field-icon toggle-password" v-if="passwordFieldType == 'password'" @click="switchVisibility"></span>
                            <div v-if="$v.form2.ncpassword.$error">
                              <p v-if="!$v.form2.ncpassword.required" class="login-alert-msg error-content">* Enter confirm password</p>
                              <p v-if="!$v.form2.ncpassword.sameAsPassword && form2.ncpassword.length > 0" class="login-alert-msg error-content">* Password Doesn't Match</p>
                            </div>
                          </div>
                        </div>
                          <div class="form-submit" style="text-align:left">
                            <input type="submit" value="Save Changes" class="submit" name="submit" id="submit" />
                          </div>
                      </div>
                    </b-form>
                  </div>
                </div>
                <div class="tc" style="padding-top: 20%;font-weight:700;" v-if="tabThree || tabFour">
                  <img src="../assets/img/empty_page.svg" alt="Product Image" style="width: 200px;">
                    <br>
                  <span style="font-size: 12px;">We'll update shortly</span>
                  <!-- <p style="font-size: 11px;color: gray;">"We'll notify your once we have something for you"</p> -->
                </div>
              </div>
            </div>
        <!-- end tab -->
      </div>
      <!-- /.box-body -->
    </div>
    <!-- /.box -->
    <div class="modal fade1 in" v-if="showmodal" style="display: block;">
      <div class="modal-dialog" style="width: 40% !important;">
        <div class="modal-content">
          <div class="modal-header" style="padding: 6px !important;">
            <button type="button" @click="close()" class="close" data-dismiss="modal" aria-label="Close">
              <i aria-hidden="true" class="uil uil-times"></i>
            </button>
            <h5 class="modal-title">Invite Users</h5>
          </div>
          <div class="modal-body">
            <b-form class="register-form" id="resets">
              <div class="mt-2" v-for="(row, index) in rows" :key="row.role">
                <!-- <div class="col-md-6 mt-2">
                  <div class="form-select">
                    <select class="form-control" v-model="row.role">
                      <option value="Recruitment">Recruitment </option>
                    </select>
                    <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                  </div>
                </div> -->
                <div class="form-group row" v-if="rows.length > 1">
                  <div class="col-md-10 mt-2" style="font-weight: bold;">
                    User {{ index + 1 }}
                  </div>
                  <div class="col-md-2 mt-2">
                    <span @click="removeElement(row, index)" style="color:red;cursor:pointer; font-weight: bold; font-size:12px; display: flex; align-items: end; flex-direction: row-reverse;" v-if="index > 0">Remove<i aria-hidden="true" class="uil uil-times"></i></span>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-6 mt-2">
                    <b-form-input type="text" v-model="row.email" @keyup="clear(index,$event)" placeholder="Email *" />
                    <div v-if="$v.rows.$each[index].email.$error">
                        <p class="login-alert-msg error-content mb-1">* Enter the valid email</p>
                    </div>
                    <div class="errormsg" v-if="row.status == 'domain'">
                        <p class="login-alert-msg error-content mb-1">* Already exist the domain user!</p>
                    </div>
                    <div class="errormsg" v-if="row.status == 'exist'">
                        <p class="login-alert-msg error-content mb-1">* Already exist the user!</p>
                    </div>
                  </div>
                  <div class="col-md-6 mt-2">
                    <vue-tel-input
                      class="form-control"
                      id="ph_val"
                      placeholder="Mobile Number"
                      @onInput="onInput"
                      @input="Check($event, index)"
                    ></vue-tel-input>
                    <!-- <div v-if="!isValiedmobileNumber[index]">
                      <p class="login-alert-msg error-content">* Enter valid mobile number</p>
                    </div> -->
                    <div v-if="$v.rows.$each[index].mobile_number.$error">
                      <p v-if="!$v.rows.$each[index].mobile_number.required" class="login-alert-msg error-content mb-1">* Enter your mobile number</p>
                      <p v-else-if="!$v.rows.$each[index].mobile_number.minLength" class="login-alert-msg error-content mb-1">* Enter a valid mobile number</p>
                      <p v-else-if="!$v.rows.$each[index].mobile_number.maxLength" class="login-alert-msg error-content mb-1">* Enter a valid mobile number</p>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-6 mt-2">
                    <b-form-input type="text" v-model="row.first_name" placeholder="First name *" />
                    <div v-if="$v.rows.$each[index].first_name.$error">
                        <p class="login-alert-msg error-content mb-1">* Enter the first name</p>
                    </div>
                  </div>
                  <div class="col-md-6 mt-2">
                    <b-form-input type="text" v-model="row.last_name" placeholder="Last name *" />
                    <div v-if="$v.rows.$each[index].last_name.$error">
                        <p class="login-alert-msg error-content mb-1">* Enter the last name</p>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-6 mt-2">
                    <b-form-input type="text" v-model="row.team_name" placeholder="Team name *" />
                    <div v-if="$v.rows.$each[index].team_name.$error">
                        <p class="login-alert-msg error-content mb-1">* Enter the team name</p>
                    </div>
                  </div>
                  <div class="col-md-6 mt-2">
                    <!-- <div class="col-md-2" style="padding: 10px;">
                      <span @click="removeElement(row)" style="color:red;cursor:pointer" v-if="index > 0"><i aria-hidden="true" class="uil uil-times"></i></span>
                    </div> -->
                  </div>
                </div>
                <!-- <div class="col-md-2" style="padding: 10px;">
                  <span @click="removeElement(row)" style="color:red;cursor:pointer" v-if="index > 0"><i aria-hidden="true" class="uil uil-times"></i></span>
                </div> -->
              </div>
              <!-- <div v-if="pskillerror" class="row">
                <p class="login-alert-msg error-content col-md-12 tc mt-10 errorshow">Please fill all the fields *{{$v.rows[index]}}</p>
              </div> -->
            </b-form>
          </div>
          <div class="modal-footer">
            <!-- <a @click="addRow" class="mr-11" style="color: #0000ffa3;">Add another user</a> -->
            <button type="button" @click="submit()" class="btn sbtn">Send Invitation</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <div class="modal fade1 in" v-if="viewdetails" style="display: block;">
      <div class="modal-dialog" style="width: 40% !important;">
        <div class="modal-content">
          <div class="modal-header" style="padding: 6px !important;">
            <button type="button" @click="detailsclose()" class="close" data-dismiss="modal" aria-label="Close">
              <i aria-hidden="true" class="uil uil-times"></i>
            </button>
            <h5 class="modal-title">Invite Users</h5>
          </div>
          <div class="modal-body">
            updated soon...
          </div>
          <div class="modal-footer">
            <a @click="addRow" class="mr-11" style="color: #0000ffa3;">Add another user</a>
            <button type="button" @click="submit()" class="btn sbtn">Send Invitation</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </section>
</template>

<script>

import axios from 'axios'
import { BaseURLV3 } from '../shared/classes'
import router from '../router/index'
import { validationMixin } from 'vuelidate'
import { required, email, sameAs, minLength, maxLength } from 'vuelidate/lib/validators'
import Vue from 'vue'
import { VueTelInput } from 'vue-tel-input'
// import { Carousel, Slide } from 'vue-carousel'
import moment from 'moment'
Vue.use(moment)
const formShape = {
  role: '',
  email: '',
  mobile_number: '',
  first_name: '',
  last_name: '',
  team_name: '',
  status: 'success'
}
const formShape2 = {
  cpassword: '',
  npassword: '',
  ncpassword: ''
}
export default {
  name: 'tabs-card',
  components: {
    VueTelInput
  },
  data () {
    return {
      title: '',
      showmodal: false,
      pskillerror: false,
      form: Object.assign({}, formShape),
      form2: Object.assign({}, formShape2),
      rows: [
        { role: 'Recruitment', email: '', mobile_number: '', first_name: '', lats_name: '', team_name: '', status: 'success' }
      ],
      showlist: false,
      viewdetails: false,
      adduser: true,
      userInfo: JSON.parse(localStorage.getItem('user__details')),
      emailmsg: '',
      userslist: [],
      userslistlength: 0,
      tabOne: true,
      tabTwo: false,
      tabThree: false,
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      tabFour: false,
      olderror: false,
      passwordFieldType: 'password',
      password_length: 0,
      paswordStrength: 0,
      passwordFieldType1: 'password',
      isValiedmobileNumber: [true],
      currentIndex: 0
    }
  },
  computed: {
    formStr () {
      return JSON.stringify(this.rows, null, 4)
    },
    isValid () {
      return !this.$v.rows.$anyError
    },
    isDirty () {
      return this.$v.rows.$anyDirty
    },
    invCheck () {
      return 'You must accept before submitting'
    }
  },
  mixins: [validationMixin],
  validations: {
    rows: {
      $each: {
        role: {
          required
        },
        email: {
          required, email
        },
        mobile_number: {
          required,
          maxLength: maxLength(10),
          minLength: minLength(10)
        },
        first_name: {
          required
        },
        last_name: {
          required
        },
        team_name: {
          required
        }
      }
    },
    form2: {
      cpassword: {
        required
      },
      npassword: {
        required
      },
      ncpassword: {
        required,
        sameAsPassword: sameAs('npassword')
      }
    }
  },
  // components: {
  //   Carousel,
  //   Slide
  // },
  created () {
    if (this.userInfo.master_id !== null) {
      this.tabOne = false
      this.tabTwo = true
    }
    this.getPostdata()
  },
  methods: {
    checkNum (phoneNumber) {
      const regEx = /^[0-9]$/
      var num = phoneNumber % 10
      if (regEx.test(num)) {
        return true
      } else {
        return false
      }
    },
    Check (e, index) {
      console.log('enter check', e)
      this.currentIndex = index
      if (!this.checkNum(e)) {
        this.isValiedmobileNumber[Number(index)] = false
      } else {
        this.isValiedmobileNumber[Number(index)] = true
      }
      console.log('this.isValiedmobileNumber4 ', this.isValiedmobileNumber)
    },
    onInput ({ number, isValid, country }) {
      this.isValiedmobileNumber[this.currentIndex] = isValid
      console.log('index ', this.currentIndex)
      console.log('number, isValid, country ', number, isValid, country)
      console.log('this.rows ', this.rows)
      this.rows[this.currentIndex].mobile_number_country_code = country.dialCode
      this.rows[this.currentIndex].mobile_number = number.significant
    },
    changepass () {
      this.olderror = false
    },
    getdate (x) {
      const d = moment().add(x, 'days')
      return moment(d).format('DD MMM YYYY')
    },
    handleSlideClick (dataset) {
      console.log(dataset.index, dataset.name)
    },
    switchVisibility () {
      this.password_length = this.form2.npassword.length
      console.log(this.form.user_password)
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    switchVisibility1 () {
      this.passwordFieldType1 = this.passwordFieldType1 === 'password' ? 'text' : 'password'
    },
    viewusers () {
      this.showlist = true
      this.adduser = false
    },
    back () {
      this.showlist = false
      this.adduser = true
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    chkState2 (val) {
      const field = this.$v.form2[val]
      return !field.$dirty || !field.$invalid
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    },
    open () {
      this.rows = []
      this.showmodal = true
      this.addRow()
      this.$v.$reset()
    },
    close () {
      this.showmodal = false
    },
    detailsview () {
      this.viewdetails = true
    },
    detailsclose () {
      this.viewdetails = false
    },
    clear (index, email) {
      this.emailmsg = ''
      this.rows[index].status = 'success'
      console.log(index)
      console.log(email.target.value)
      console.log(this.userInfo.email)
      const all = this.userInfo.email.split('@')
      const ne = email.target.value.split('@')
      console.log(all[1])
      console.log(ne[1])
      if (all[1] !== ne[1]) {
        this.rows[index].status = 'domain'
        return false
      }
      // const data = {
      //   user_email: email.target.value
      // }
      // const mainurl = '/profile/validate_email'
      // axios.post(`${BaseURL}${mainurl}`, { formData: data }, this.config).then(response => {
      //   console.log(response.data.message)
      //   if (!this.$v.rows.$each[index].email.$error) {
      //     if (response.data.message === 'User already exists') {
      //       this.rows[index].status = 'exist'
      //     } else {
      //       this.rows[index].status = 'success'
      //     }
      //   }
      // }).catch(e => {
      //   console.log(e)
      //   router.push({ name: 'Login_v3' })
      // })
    },
    addRow () {
      // this.isValiedmobileNumber[this.rows.length + 1] = true
      this.isValiedmobileNumber.push(true)
      this.rows.push({ role: 'Recruitment', email: '', mobile_number: '', first_name: '', lats_name: '', team_name: '', status: 'success' })
    },
    removeElement (row, ind) {
      const index = this.rows.indexOf(row)
      this.rows.splice(index, 1)
      this.isValiedmobileNumber.splice(ind, 1)
    },
    submit () {
      if (this.validate()) {
        for (let m = 0; m < this.rows.length; m++) {
          console.log(this.rows[m].status)
          if (this.rows[m].status !== 'success') {
            return false
          }
        }
        console.log(this.rows)
        this.$nextTick(() => {
          const data = {
            // user_mailids: this.rows,
            // master_user_id: this.userInfo._id
            email: this.rows[0].email,
            first_name: this.rows[0].first_name,
            last_name: this.rows[0].last_name,
            mobile_country_code: this.rows[0].mobile_number_country_code,
            mobile: this.rows[0].mobile_number,
            team_name: this.rows[0].team_name
          }
          const mainurl = '/org/' + this.userInfo.id + '/add_team'
          axios.post(`${BaseURLV3}${mainurl}`, data, this.config).then(response => {
            this.close()
            this.getPostdata()
            this.$awn.success('Added successfully')
          }).catch(e => {
            console.log(e)
          })
        })
      }
    },
    onSubmitProfile () {
      if (!this.$v.form2.$error) {
        const data = {
          new_password: this.form2.npassword,
          old_password: this.form2.cpassword
        }
        const mainurl = '/org/' + this.userInfo.user_id + '/change_password'
        axios.post(`${BaseURLV3}${mainurl}`, data, this.config).then(response => {
          if (response.data.success) {
            // localStorage.setItem('user__details', JSON.stringify(response.data.userdetail))
            this.form2.npassword = ''
            this.form2.ncpassword = ''
            this.form2.cpassword = ''
            this.$v.$reset()
            this.$awn.success(response.data.msg)
          } else {
            if (response.data.msg === 'Please check your password') {
              this.olderror = true
              return false
            } else {
              this.olderror = false
            }
          }
        }).catch(e => {
          console.log(e)
        })
      }
    },
    getPostdata () {
      const mainurl = '/org/' + this.userInfo.id + '/get_team'
      axios.get(`${BaseURLV3}${mainurl}`, this.config).then(response => {
        if (response.data.success) {
          this.userslist = response.data.teams
          this.userslistlength = response.data.teams.length
          this.rows = []
          this.addRow()
        }
      }).catch(e => {
        console.log(e)
      })
    },
    navigation (tabs) {
      router.push({ name: tabs })
    }
  }
}
</script>

<style scoped>
.products-list .item:hover {
  border-left: 3px solid #ffffff;
  background-color: #ffffff;
  cursor: pointer;
}
a:hover, a:active, a:focus {
  outline: none;
  text-decoration: none;
  color: #5bad2b;
}
.errorshow {
  background-color: #ff000047;
  padding: 5px;
  color: #dd4b39 !important;
}
.post li.active {
  background-color: #5bad2b !important;
  color: white !important;
  border: 0px !important;
}
.sideborder {
  border-right: 1px solid #cccccc52;
  min-height: 700px;
  height: 100%;
}
span.field-icon {
  position: absolute;
  display: inline-block;
  cursor: pointer;
  right: 2.5rem;
  top: 0.7rem;
  z-index: 2;
  margin-top: 4px;
}
.nav-stacked>li.active>a, .nav-stacked>li.active>a:hover {
    background: transparent;
    color:white;
    border-top: 0;
    border-left-color: #5bad2b ;
}
.vue-tel-input {
  padding: 0px !important;
}
</style>>
